import React from "react";

import workPassportCommandCentreWorkforceReadinessDashboardDesktop from "../../images/work-passport-command-centre-workforce-readiness-dashboard-desktop.svg";
import workPassportCommandCentreWorkforceReadinessDashboardMobile from "../../images/work-passport-command-centre-workforce-readiness-dashboard-mobile.svg";

import "./WorkPassportCommandCentre.css";

const WORK_PASSPORT_COMMAND_CENTRE_STATES = [
  { label: "Ready", tone: "ready" },
  { label: "Expiring soon", tone: "expiring" },
  { label: "Action required", tone: "action" },
  { label: "Training scheduled", tone: "scheduled" },
];

export default function WorkPassportCommandCentre() {
  return (
    <section
      className="work-passport-command-centre"
      id="work-passport-command-centre"
      aria-labelledby="work-passport-command-centre-title"
    >
      <div className="work-passport-command-centre__inner">
        <header className="work-passport-command-centre__header">
          <p className="work-passport-command-centre__eyebrow">
            <span aria-hidden="true" />
            Workforce readiness at a glance
          </p>
          <div className="work-passport-command-centre__heading-grid">
            <h2 id="work-passport-command-centre-title">
              Know who is ready—and why.
            </h2>
            <p>
              View workforce readiness across sites, positions, teams and
              individual employees from one operational command centre.
            </p>
          </div>
        </header>

        <picture className="work-passport-command-centre__visual">
          <source
            media="(max-width: 620px)"
            srcSet={workPassportCommandCentreWorkforceReadinessDashboardMobile}
          />
          <img
            src={workPassportCommandCentreWorkforceReadinessDashboardDesktop}
            alt="Illustrative Work Passport dashboard showing workforce readiness, upcoming expiries and employee status"
          />
        </picture>

        <ul className="work-passport-command-centre__states">
          {WORK_PASSPORT_COMMAND_CENTRE_STATES.map((item) => (
            <li
              key={item.label}
              className={`work-passport-command-centre__state work-passport-command-centre__state--${item.tone}`}
            >
              <i aria-hidden="true" />
              {item.label}
            </li>
          ))}
        </ul>
      </div>
    </section>
  );
}
